import React from "react";

const BackToTopButton = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="d-flex align-items-end">
      <button
        type="button"
        className="BackToTopButton"
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <span className="arrow">
          <i
            className="bi bi-chevron-double-up text-white fs-4"
            aria-hidden="true"
          ></i>
        </span>
      </button>
    </div>
  );
};

export default BackToTopButton;